import { CredentialsForm } from "./CredentialsForm"

/** Страница обязательной настройки учётной записи после первого входа с временными данными. */
export function ForceChange({ currentPassword, onDone }: { currentPassword: string; onDone: () => void }) {
  return (
    <div className="min-h-[100dvh] flex items-center justify-center bg-[#020617] px-4">
      <div className="relative w-full max-w-sm">
        <div className="rounded-2xl border border-white/[8%] bg-white/[3%] backdrop-blur-sm p-8 shadow-2xl shadow-black/40">
          <h1 className="text-xl font-bold text-zinc-100 mb-1">Настройка учётной записи</h1>
          <p className="text-sm text-zinc-400 mb-5">
            Вы вошли с временными данными. Выберите свой логин и пароль — пока этого не сделано, чат и остальные
            разделы закрыты. Временный пароль после этого перестанет работать.
          </p>
          <CredentialsForm currentPassword={currentPassword} submitLabel="Сохранить и войти заново" onDone={onDone} />
        </div>
      </div>
    </div>
  )
}
